import * as React from 'react';
import { useState, useEffect } from 'react';
import { fileIconBasedOnFileName } from '../../containers/WorkkardDetail/utils';
import { FileListing } from '../../containers/WorkkardDetail/constants';
import Icons from '../../icons';
import { getImagePreview } from '../../common/util';

export const IMAGE_TYPE = new Set(['jpg', 'jpeg', 'png', 'Image']);

// Files mislabeled with a generic "other" type but an .esx extension get a dedicated icon.
const resolveFileType = (fileType, fileName) => {
    if (fileType !== "other") return fileType;
    const extension = (fileName || '').substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    return extension === "esx" ? 'esx' : fileType;
};

const WorkkardCell = (props) => {
    const { file_name, guid, file_size, caption, type, file_type } = props.data;
    const [isSelected, setIsSelected] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const isImageFile = IMAGE_TYPE.has(file_type);

    // getImagePreview fetches the preview.
    useEffect(() => {
        if (!isImageFile || !guid) {
            setPreviewUrl(null);
            return undefined;
        }
        setPreviewUrl(null);
        return getImagePreview(guid, setPreviewUrl);
    }, [guid, isImageFile]);

    const fileType = resolveFileType((file_type || '').toLowerCase(), file_name);
    const iconProps = { name: fileIconBasedOnFileName(fileType) };

    const handleClick = () => {
        props.onItemClick({
            guid: guid,
            name: file_name,
            size: file_size,
            caption: caption,
            url: previewUrl
        });
        setIsSelected((prevSelected) => !prevSelected);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    };

    const isCommunityFile = type === 'Community';
    const isCaptionTruncated = caption && caption.length > FileListing.maxLengthToTruncateFileName;
    const displayCaption = isCaptionTruncated
        ? caption.substring(FileListing.startIndexOfSubstringTruncateFileName, FileListing.endIndexOfSubstringTruncateFileName) + "..."
        : caption;
    
    return (
        <li
            className={isSelected ? 'select_attachment' : ''}
            role="button"
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
        >
            <div className="img_attachment">
                {isImageFile
                    ? <img src={previewUrl} alt={file_name || 'workkard file'} />
                    : (
                        <div className="filesMain">
                            <Icons {...iconProps} />
                        </div>
                    )
                }
                <span className={isSelected ? 'badges profileChecked green' : ''}></span>
            </div>
            <div className={`caption_attachment colFlex ${isCommunityFile ? 'personal' : 'public'}`}>
                <span title={file_name || 'workard_files'} className="flname">{file_name}</span>
                {caption &&
                    <label title={caption} className="flcaption">{displayCaption}</label>
                }
                <span className="ico"></span>
            </div>
            <div className={`caption_attachment alignMiddle ${isCommunityFile ? 'personal' : 'public'} ${isSelected ? 'active' : ''}`}>
                <em title=""></em>
            </div>
        </li>
    );
};

export default WorkkardCell;
